import { render, staticRenderFns } from "./PokeCard.vue?vue&type=template&id=1988aa29&scoped=true&"
import script from "./PokeCard.vue?vue&type=script&lang=js&"
export * from "./PokeCard.vue?vue&type=script&lang=js&"
import style0 from "./PokeCard.vue?vue&type=style&index=0&id=1988aa29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988aa29",
  null
  
)

export default component.exports